import React from 'react'
import { useTranslation } from 'react-i18next'
import MainIcon from '../../../../../img/svg/main'
import { TextBig } from '../../OrdersTable/index.styled'
import { TableTdGrid } from '../../style/table/td/index.styled'
import CanceledInvoiceIcon from '../../InvoicesTable/modal/CanceledInvoiceIcon'
import { getInvoiceViewStatus, INVOICE_STATUS } from '../../InvoicesTable/constants'
import { INVOICE_STATUS_VIEW } from './constants'

const InvoiceStatus = React.memo(({ item }) => {
	const { t } = useTranslation()
	const status = getInvoiceViewStatus(item)
	const statusView = INVOICE_STATUS_VIEW[status]

	return (
		<TableTdGrid className={statusView.className}>
			{status === INVOICE_STATUS.CANCELED ? <CanceledInvoiceIcon /> : <MainIcon icon={statusView.icon} />}
			<TextBig>{t(statusView.label)}</TextBig>
		</TableTdGrid>
	)
})

InvoiceStatus.displayName = 'InvoiceStatus'
export default InvoiceStatus
